module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin1-8c677e34f2522bca4a0dc853c710d743.jpg";